import fetch from "../fetch";

export default ({ params = {} } = {}) =>
  fetch({ path: `/hy/contact-types`, params });
